import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { TestIds } from '@investown/fe/test-utils/testIds';

import { ReactComponent as SvgLogo } from 'assets/images/logo.svg';

const NavbarLogo: FC = () => (
  <LogoHolder data-testid={TestIds.NavbarLogo} to="/" className="gx-site-logo">
    <SvgLogo />
  </LogoHolder>
);

const LogoHolder = styled(Link)`
  width: 150px;
  height: auto;
  position: relative;
  z-index: 10;

  svg {
    height: 20px;
    width: 100%;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.mini}) {
    width: 130px;
  }
`;

export default NavbarLogo;
